import { ReactElement } from 'react';
import { Link } from 'react-router';
import { noop } from 'libs';

interface AsideLinkProps {
  hasNotification?: boolean;
  icon: ReactElement;
  label: string;
  onClick?: () => void;
  testId?: string;
  to: string;
}

const AsideLink = ({ hasNotification = false, icon, label, onClick = noop, testId, to }: AsideLinkProps) => (
  <Link className="list-group-item list-group-item-action" onClick={onClick} data-testid={testId} to={to}>
    <span className="settings-link__icon d-inline-block w-6">
      {icon}
      {hasNotification && (
        <span
          aria-hidden="true"
          className="aside-menu__notification-dot"
          data-testid={testId ? `${testId}-notification` : undefined}
        />
      )}
    </span>
    {label}
  </Link>
);

export default AsideLink;
